import { useContext } from 'react';

import * as yup from 'yup';

import { type TaxpayerRegistrationFieldConfiguration } from '../../TaxpayerRequestEvaluation/types';
import { TaxpayerRegistrationContext } from '../pages/request';

/**
 * Regla de validación
 *
 * @export
 * @interface ValidationRule
 */
export interface TaxpayerFieldValidationRule {
  /**
   * Identificador del campo (o lo campos)
   *
   * @type {string}
   * @memberof TaxpayerFieldValidationRule
   */
  field?: string;

  /**
   * Validación asociada
   *
   * @type {yup.AnySchema}
   * @memberof TaxpayerFieldValidationRule
   */
  validation: yup.ObjectShape;
}

interface ValidationsResolverProps {
  rules: Array<TaxpayerFieldValidationRule>;
  children?: any;
}

export const ValidationsResolver = ({ children, rules }: ValidationsResolverProps) => {
  const conf: TaxpayerRegistrationFieldConfiguration =
    useContext<TaxpayerRegistrationFieldConfiguration>(TaxpayerRegistrationContext);

  // se filtran de todas las reglas que se tienen definidas cuales son las que se van a aplicar
  const appliedRules = rules.filter(
    (rule: TaxpayerFieldValidationRule) =>
      rule.field == undefined || conf.fields.some((x) => x == rule.field)
  );

  function builderYupValidations() {
    const yupSchemas = appliedRules.map((x) => yup.object().shape(x.validation));
    if (yupSchemas.length === 0) {
      return yup.object().shape({});
    }
    const validations = yupSchemas.reduce((previousValue, currentValue) =>
      currentValue.concat(previousValue)
    );

    return validations;
  }

  const validationsYup = builderYupValidations();

  return <>{children({ validations: validationsYup })}</>;
};
